import { RocketOutlined } from '@ant-design/icons'

const Rocket = ({ ...props }) => {
  return <RocketOutlined className="text-[20px] cursor-pointer" {...props} />
}

export default Rocket
